<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Edit Banner
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title *"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="formErrors.title"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.tag_text"
                outlined
                label="Tag Text (Optional)"
                prepend-inner-icon="mdi-tag-outline"
                :error-messages="formErrors.tag_text"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <label for="description" class="dark-label">Description *</label>
              <vue-editor
                ref="description"
                v-model="form.description"
                class="form-control"
                :error-messages="formErrors.description"
              />
            </v-col>
          </v-row>
          <v-row class="mt-4">
            <v-col sm="6">
              <v-select
                v-model="form.target_user_type"
                outlined
                label="Target User Type *"
                :items="userTypes"
                item-text="text"
                item-value="value"
                prepend-inner-icon="mdi-account-group"
                :error-messages="formErrors.target_user_type"
              ></v-select>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.priority"
                outlined
                type="number"
                label="Priority"
                prepend-inner-icon="mdi-sort-numeric-variant"
                :error-messages="formErrors.priority"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.valid_from"
                outlined
                type="datetime-local"
                label="Valid From *"
                prepend-inner-icon="mdi-calendar-start"
                :error-messages="formErrors.valid_from"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.valid_until"
                outlined
                type="datetime-local"
                label="Valid Until *"
                prepend-inner-icon="mdi-calendar-end"
                :error-messages="formErrors.valid_until"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col sm="12">
              <v-checkbox
                v-model="form.show_timer"
                label="Show Timer"
                :error-messages="formErrors.show_timer"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="form.show_timer">
            <v-col sm="6">
              <v-text-field
                v-model="form.timer_duration_seconds"
                outlined
                type="number"
                label="Timer Duration (seconds)"
                prepend-inner-icon="mdi-timer-outline"
                :error-messages="formErrors.timer_duration_seconds"
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.cta_text"
                outlined
                label="CTA Button Text (Optional)"
                prepend-inner-icon="mdi-cursor-pointer"
                :error-messages="formErrors.cta_text"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.cta_url"
                outlined
                label="CTA URL (Optional)"
                prepend-inner-icon="mdi-link-variant"
                :error-messages="formErrors.cta_url"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-switch
                v-model="form.is_primary"
                label="Set as Primary Banner"
                color="primary"
                hint="Only one banner can be primary at a time. Setting this will make all other banners non-primary."
                persistent-hint
                :error-messages="formErrors.is_primary"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="6">
              <label for="image_path">Banner Image</label>
              <input
                type="file"
                id="image_path"
                name="image_path"
                ref="image_path"
                accept="image/*"
                @change="onFileChange"
              />
              <v-btn
                v-if="image_url || form.image_path"
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.image_path.value = null), (image_url = null)"
              >
                Remove
              </v-btn>
            </v-col>
            <v-col sm="6">
              <v-switch
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row v-if="image_url || form.image_path">
            <v-col sm="12">
              <div id="preview" class="mt-5">
                <label>Image Preview</label>
                <br />
                <img
                  :src="image_url || (mediaUrl + form.image_path)"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn v-can:edit="'banners'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Banner
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";

export default {
  name: "BannerEditPage",
  components: {
    VueEditor,
  },
  data() {
    return {
      form: {
        title: "",
        description: "",
        tag_text: "",
        image_path: "",
        show_timer: false,
        timer_duration_seconds: null,
        target_user_type: "all",
        valid_from: "",
        valid_until: "",
        priority: 0,
        cta_text: "",
        cta_url: "",
        is_active: true,
        is_primary: false,
      },
      userTypes: [
        { text: "All Users", value: "all" },
        { text: "New Users (< 30 days)", value: "new" },
        { text: "Existing Users (> 30 days)", value: "existing" },
        { text: "Inactive Users (no login 30+ days)", value: "inactive" },
      ],
      formErrors: {},
      isLoading: false,
      isFetching: false,
      image_url: null,
      file: null,
      old_json: null,
    };
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getData();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.bannerId;
      await axios
        .get(`/banners/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = JSON.parse(JSON.stringify(response.data.data));

          // Format datetime fields for datetime-local input
          if (this.form.valid_from) {
            this.form.valid_from = this.formatDateTimeForInput(this.form.valid_from);
          }
          if (this.form.valid_until) {
            this.form.valid_until = this.formatDateTimeForInput(this.form.valid_until);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.isShowPopUP("Error", "Failed to load banner data", "error");
        });
      this.isLoading = false;
    },
    formatDateTimeForInput(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    onFileChange() {
      this.file = this.$refs.image_path?.files[0];
      if (this.file) {
        this.image_url = URL.createObjectURL(this.file);
      }
    },
    async save() {
      try {
        this.isLoading = true;
        this.formErrors = {};

        await axios
          .patch(`/banners/${this.$route.params.bannerId}`, this.form)
          .then(async () => {
            await this.handleFileUpload();
            await this.saveUserTimestamp(this.old_json, this.form);
            this.isLoading = false;
            this.isShowPopUP("Success", "Banner updated successfully", "success");
            this.$router.push("/banners");
          })
          .catch((error) => {
            this.isLoading = false;
            if (error.response && error.response.status === 422) {
              this.formErrors = error.response.data.errors || {};
            }
            this.isShowPopUP("Error", error.response?.data?.message || "An error occurred", "error");
          });
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },
    async handleFileUpload() {
      console.log("handleFileUpload called");
      let formData = new FormData();
      formData.append("id", this.form.id);

      // Only upload if a new image was selected
      if (this.$refs.image_path?.files[0]) {
        this.image_path = this.$refs.image_path.files[0];
        formData.append("image_path", this.image_path);

        await axios
          .post("banners/upload_banner", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .catch((error) => {
            console.error("Upload error:", error);
            this.isShowPopUP(
              "Upload Error",
              "Failed to upload banner image",
              "error"
            );
          });
      }
    },
  },
};
</script>
